import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import api from '../api';

const AdminProtectedRoute = ({ children }) => {
    const [hasAccess, setHasAccess] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkAdminStatus = async () => {
            try {
                // Use cookie-based auth (same as ProtectedRoute) — no token check needed.
                // The __ttauth cookie is sent automatically via withCredentials: true.
                const response = await api.get('/api/user');
                // Normalise role — handle legacy 'super admin' (space) and current 'super_admin' (underscore)
                const userRole = (response.data.role || '').toLowerCase().replace(' ', '_');
                // Both 'admin' and 'super_admin' can access the admin dashboard
                setHasAccess(userRole === 'admin' || userRole === 'super_admin');
            } catch (error) {
                setHasAccess(false);
            } finally {
                setLoading(false);
            }
        };

        checkAdminStatus();
    }, []);

    if (loading) {
        return <div style={{ color: 'white', padding: '20px' }}>Loading...</div>;
    }

    return hasAccess ? children : <Navigate to="/home" />;
};

export default AdminProtectedRoute;